import { useEffect, useState } from 'react';
import axios from 'axios';

const API = 'https://ticobaterias.com/api';

const ESTADOS = ['pendiente','atendido','cerrado'];
const COLORES: any = { pendiente:'bg-yellow-100 text-yellow-700', atendido:'bg-blue-100 text-blue-700', cerrado:'bg-gray-100 text-gray-500' };

export default function Cotizaciones() {
  const [cotizaciones, setCotizaciones] = useState([]);
  const [filtro, setFiltro] = useState('todos');
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const cargar = () => axios.get(`${API}/cotizaciones/`, { headers }).then(r => setCotizaciones(r.data));
  useEffect(() => { cargar(); }, []);

  const cambiarEstado = async (id: number, estado: string) => {
    await axios.put(`${API}/cotizaciones/${id}/estado`, { estado }, { headers });
    cargar();
  };

  const filtradas = filtro === 'todos' ? cotizaciones : (cotizaciones as any[]).filter((c: any) => c.estado === filtro);

  const whatsapp = (c: any) => {
    const msg = `Hola ${c.nombre_cliente}, gracias por contactarnos. ¿En qué podemos ayudarle?`;
    window.open(`https://wa.me/${c.telefono?.replace(/\D/g,'')}?text=${encodeURIComponent(msg)}`, '_blank');
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="font-bold text-2xl text-azul">Cotizaciones</h1>
          <p className="text-gray-500 text-sm">{cotizaciones.length} mensajes recibidos</p>
        </div>
        <div className="flex gap-2">
          {['todos', ...ESTADOS].map(e => (
            <button key={e} onClick={() => setFiltro(e)}
              className={`px-4 py-2 rounded-xl text-xs font-bold border transition-colors capitalize ${filtro === e ? 'bg-azul text-white border-azul' : 'bg-white text-gray-500 border-gray-200 hover:border-azul'}`}>
              {e}
            </button>
          ))}
        </div>
      </div>
      <div className="space-y-3">
        {(filtradas as any[]).map((c: any) => (
          <div key={c.id} className="bg-white rounded-2xl border border-gray-100 p-5 hover:border-azul/30 transition-colors">
            <div className="flex justify-between items-start mb-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-azul rounded-full flex items-center justify-center text-white font-black text-sm flex-shrink-0">
                  {c.nombre_cliente?.charAt(0)}
                </div>
                <div>
                  <div className="font-bold text-azul">{c.nombre_cliente}</div>
                  <div className="text-gray-400 text-xs">{new Date(c.creado_en).toLocaleDateString('es-CR')} — {new Date(c.creado_en).toLocaleTimeString('es-CR', {hour:'2-digit',minute:'2-digit'})}</div>
                </div>
              </div>
              <span className={`text-xs px-3 py-1 rounded-full font-bold capitalize ${COLORES[c.estado]}`}>{c.estado}</span>
            </div>
            <div className="bg-gray-50 rounded-xl p-4 mb-4">
              <p className="text-gray-700 text-sm leading-relaxed">{c.mensaje}</p>
            </div>
            <div className="flex items-center justify-between flex-wrap gap-3">
              <div className="flex gap-4 text-sm text-gray-500">
                {c.telefono && <span>📞 {c.telefono}</span>}
                {c.email && <span>✉️ {c.email}</span>}
              </div>
              <div className="flex gap-2">
                {c.telefono && (
                  <button onClick={() => whatsapp(c)} className="bg-green-500 text-white px-4 py-2 rounded-lg text-xs font-bold hover:bg-green-600 transition-colors">
                    💬 Responder WA
                  </button>
                )}
                <select value={c.estado} onChange={e => cambiarEstado(c.id, e.target.value)}
                  className="border border-gray-200 rounded-lg px-3 py-2 text-xs font-bold focus:outline-none focus:border-azul">
                  {ESTADOS.map(e => <option key={e} value={e} className="capitalize">{e}</option>)}
                </select>
              </div>
            </div>
          </div>
        ))}
        {filtradas.length === 0 && (
          <div className="text-center py-16 text-gray-400 bg-white rounded-2xl border border-gray-100">
            <div className="text-4xl mb-3">💬</div>
            <p>No hay cotizaciones {filtro !== 'todos' ? `con estado "${filtro}"` : 'aún'}</p>
          </div>
        )}
      </div>
    </div>
  );
}
